var jade = require("C:\\Dev\\repos\\player\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
jade_debug.unshift(new jade.DebugItem( 0, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"row subtitle\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 2, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"col title\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 3, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"title-number\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 4, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"col time\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 5, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"time-start\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"time-end\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 8, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"col text original\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 9, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"row1-original row1\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 10, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"row2-original row2\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 11, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"black-bg\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 13, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"col text edited\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"row1-edited row1\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, jade_debug[0].filename ));
buf.push(" ");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 15, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-item.jade" ));
buf.push("<div class=\"row2-edited row2\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, ".row.subtitle\r\n\t.col.title\r\n\t\t.title-number\r\n\t.col.time\r\n\t\t.time-start\r\n\t\t.time-end\r\n\r\n\t.col.text.original\r\n\t\t.row1-original.row1\r\n\t\t.row2-original.row2\r\n\t\t.black-bg\r\n\r\n\t.col.text.edited\r\n\t\t.row1-edited.row1 \r\n\t\t.row2-edited.row2\r\n");
}
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/subtitle-item.jade
// module id = 423
// module chunks = 0